import React, { Component } from "react";
import axios from "axios";
import $ from "jquery";
import Headers from "../Layouts/Headers";
import { LabSidebar } from "../Layouts/LabSidebar";
import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";

export class UricThyroidCoagulationElisa extends Component {
  constructor(props) {
    super(props);

   

    const url = "";
    this.state = {
      UricAcid: "",
      thyroidt3: "",
      thyroidt4: "",
      thyroidtsh: "",
      coagulationpt: "",
      coagulationptt: "",
      coagulationaptt: "",
      elisameaslesigm: "",
      elisarubellaigm: "",
      elisahbsag: "",
      elisahcv: "",
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.modal = true;
  }

  componentDidMount() {
    var rowNumber = this.state["rowNumber"];
    var tableRow =
      '<tr><td><input className="form-control" name="Year" onChange={this.handleChange} value={Year}  type="text" required/> </td><td><textarea className="form-control" name="EvolutionPreviousPregnancy" onChange={this.handleChange} value={EvolutionPreviousPregnancy}></textarea></td><td><textarea className="form-control" name="InfantWeight" onChange={this.handleChange} value={InfantWeight}></textarea></td><td><textarea className="form-control" name="Sex" onChange={this.handleChange} value={Sex}></textarea></td> <td><textarea className="form-control" name="ModeDeliveryMode" onChange={this.handleChange} value={ModeDeliveryMode}></textarea></td><td><textarea className="form-control" name="InfantWeight" onChange={this.handleChange} value={InfantWeight}></textarea></td></tr>';
    $(".add-row").on("click", function () {
      $(".tableBody").append(tableRow);
    });
    this.setState({ rowNumber: parseInt(rowNumber) + 1 });
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  onTableChange(event) {}

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };

    event.preventDefault();
    console.log(localStorage.getItem("objectLength"));
    var objectLength = localStorage.getItem("objectLength");

    console.log(this.state.tablevaluesglobal);

    for (var i = 0; i < Object.keys(this.state.tablevaluesglobal).length; i++) {
      // console.log(this.state.tablevaluesglobal[i]['Year'])

      var year = this.state.tablevaluesglobal[i]["Year"];
      var dict = {
        UricAcid: this.state.tablevaluesglobal[i]["UricAcid"],
        thyroidt3: this.state.tablevaluesglobal[i]["thyroidt3"],
        thyroidt4: this.state.tablevaluesglobal[i]["thyroidt4"],
        thyroidtsh: this.state.tablevaluesglobal[i]["thyroidtsh"],
        coagulationpt: this.state.tablevaluesglobal[i]["coagulationpt"],
        coagulationptt: this.state.tablevaluesglobal[i]["coagulationptt"],
        coagulationaptt: this.state.tablevaluesglobal[i]["coagulationaptt"],
        elisameaslesigm: this.state.tablevaluesglobal[i]["elisameaslesigm"],
        elisarubellaigm: this.state.tablevaluesglobal[i]["elisarubellaigm"],
        elisahbsag: this.state.tablevaluesglobal[i]["elisahbsag"],
        elisahcv: this.state.tablevaluesglobal[i]["elisahcv"],
      };

      axios
        .post(
          this.api_url+"laboratory/tests/UricThyroidCoagulationElisa",
          dict,
          { headers: headers }
        )
        .then((response) => {
          console.log(response);
          // /triage/antenatal/history

          if (response.data["status"]) {
            $(".alert-success").show();
            setTimeout(function () {}, 500);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  handleTableChange(event) {
    // console.log(event);
    // this.setState({ myParentTrigger: this.state.myParentTrigger + 'a' });
  }

  formatTableOutput(data) {
    console.log(this.state.tablevaluesglobal);
  }

  getTableValues(event) {
    var data = event;
    let topobj = {};
    let tableobj = {};
    for (let i = 0; i < data.length; i++) {
      let trim = data[i];
      let trimobj = {};
      this.setState({
        Year: "1212",
      });

      trimobj.UricAcid = data[i][0];
      trimobj.thyroidt3 = data[i][1];
      trimobj.thyroidt4 = data[i][2];
      trimobj.thyroidtsh = data[i][3];
      trimobj.coagulationpt = data[i][4];
      trimobj.coagulationptt = data[i][5];
      trimobj.coagulationaptt = data[i][6];
      trimobj.elisameaslesigm = data[i][7];
      trimobj.elisarubellaigm = data[i][8];
      trimobj.elisahbsag = data[i][9];
      trimobj.elisahcv = data[i][10];
      tableobj[i] = trimobj;
      topobj.prepplan = tableobj;

      tableobj[i] = trimobj;
      topobj.prepplan = tableobj;
    }
    this.state.tablevaluesglobal = topobj["prepplan"];
    // let tablevalues = this.formatTableOutput(event);
    console.log(this.state.tablevaluesglobal);
  }

  render() {
    //Editable table variables
    const data = [["", "", "", "", "", "", "", "", "", "", ""]];

    const columns = [
      "UricAcid",
      "thyroidt3",
      "thyroidt4",
      "thyroidtsh",
      "coagulationpt",
      "coagulationptt",
      "coagulationaptt",
      "elisameaslesigm",
      "elisarubellaigm",
      "elisahbsag",
      "elisahcv:",
    ];

    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    return (
      <div>
        <Headers />
        <LabSidebar />
        <main className="content-container">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="col-md-4 text-lg-center font-weight-bold p-1">
                <p className="text-capitalize" style={font16}></p>
              </div>
              <MDBCard>
                <MDBCardHeader
                  tag="h3"
                  className="text-center font-weight-bold text-capitalise py-4"
                >
                  UricThyroidCoagulationElisa
                </MDBCardHeader>
                <MDBCardBody>
                  <MDBTableEditable
                    onChange={(value) => this.handleTableChange(value)}
                    getValue={(value) => this.getTableValues(value)}
                    myParentTrigger={this.state.myParentTrigger}
                    id="editablecard"
                    data={data}
                    columns={columns}
                    striped
                    bordered
                  />
                </MDBCardBody>
              </MDBCard>

              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details Saved Successfully.
              </div>
              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}
export default UricThyroidCoagulationElisa;
